import { useContext, useMemo } from 'react';
import * as Cesium from "cesium";
import useScenario from './useScenario';
import { CommandCenterStateProviderContext } from '../context';
import useUrlParams from './useUrlParams';
import { isOperateMode } from './utils';

const useViewer = () => {
    const context = useContext(CommandCenterStateProviderContext);
    if (context === undefined) {
        throw new Error('useViewer must be used within a ViewerProvider');
    }

    const {
        viewer,
        set_viewer,
        multiplier,
        set_multiplier,
        viewer_state,
        set_viewer_state,
        current_simulation_time,
        set_current_simulation_time,
    } = context

    const { dashboard } = useUrlParams()
    const { scenario, simulation_time, getUpdatedSimulationTime } = useScenario()
    const { start_time, end_time, duration } = useMemo(() => simulation_time, [simulation_time])

    const change_viewer_time = (value: number) => {
        const viewerStep = 1000
        const simulation_start_time = start_time * viewerStep
        const simulation_end_time = end_time * viewerStep

        if (viewer && dashboard === 'summary') {
            const julianDate = Cesium.JulianDate.fromDate(new Date(value * viewerStep));
            const current_time = Cesium.JulianDate.toDate(julianDate).getTime();
            if (current_time >= simulation_start_time && current_time <= simulation_end_time) {
                viewer.clock.currentTime = julianDate;
                set_current_simulation_time(current_time)
                // update_sat_orbit_path(viewer, current_time)
            }
        }

    };

    const go_live = () => {
        const operateMode = isOperateMode(dashboard, scenario)
        if (operateMode && scenario) {
            const currentTime = current_simulation_time / 1000
            getUpdatedSimulationTime(scenario, currentTime, currentTime, duration)
        }

    }

    const update_viewer = (map_viewer: Cesium.Viewer) => {
        try {
            map_viewer.clock.multiplier = viewer_state === 'pause' ? 0 : multiplier;
            if (current_simulation_time > 0) {
                const julianDate = Cesium.JulianDate.fromIso8601(
                    new Date(current_simulation_time).toISOString()
                );
                map_viewer.clock.currentTime = julianDate;
            }
        } catch (error) {
            set_multiplier(1)
            set_viewer_state('play')
        }
    };

    return {
        viewer,
        go_live,
        set_viewer,
        multiplier,
        set_multiplier,
        viewer_state,
        set_viewer_state,
        current_simulation_time,
        set_current_simulation_time,
        update_viewer,
        change_viewer_time
    }
};

export default useViewer;